module.exports = __webpack_public_path__ + "static/img/logo1.23378fb.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo1.png
// module id = +8pg
// module chunks = 92